export default __webpack_public_path__ + "station-defect-electrical-gray.png?3888cd70667766bb815945be978c425e";